export const securityCheck = {
  value: {
    props: {},
  },
}
